const pageableAndSortable = {
  methods: {
    handlePageUpdate (pageValue) {
      this.currentPage = pageValue
    },
    handleSortByUpdate (sortByValue) {
      this.sortBy = sortByValue
    },
    handleSortDescUpdate (sortDescValue) {
      this.sortDesc = sortDescValue
    },
    handleItemsPerPageUpdate (itemsPerPageValue) {
      this.itemsPerPage = itemsPerPageValue
    }
  }
}

export default pageableAndSortable
